export const config = {
  title: 'Bountiful Blessings Cleaning LLC | Detroit, MI',
  meta: {
    description:
      'Bountiful Blessings Cleaning LLC offers professional residential and commercial cleaning services in Detroit, MI. Reliable, efficient, and tailored to your needs.',
    keywords: [
      'Bountiful Blessings Cleaning LLC',
      'Detroit Cleaning Services',
      'Residential Cleaning Detroit',
      'Commercial Cleaning Detroit',
      'Office Cleaning Detroit',
      'Home Cleaning Detroit',
    ],
    author: 'Bountiful Blessings Cleaning LLC',
    canonicalUrl: 'https://bountifulblessingscleaningllc.com/',
  },
  sections: {
    header: {
      businessName: 'Bountiful Blessings Cleaning LLC',
    },
    sectionB: {
      heroTitle: 'Expert Cleaning Services in Detroit',
      heroSubtitle: 'Creating Clean, Safe, and Welcoming Spaces',
      learnAboutText: 'Learn More',
      phoneNumber: '3136361833',
      phoneLabel: '+1 (313) 636-1833',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=',
      cardData: [
        {
          title: 'Residential Cleaning',
          description:
            'Tailored home cleaning services to keep your living space spotless and comfortable.',
        },
        {
          title: 'Commercial Cleaning',
          description:
            'Professional cleaning solutions for offices and commercial facilities.',
        },
        {
          title: 'Customized Cleaning Plans',
          description:
            'Flexible cleaning schedules and services to meet your specific needs.',
        },
      ],
      description:
        'At Bountiful Blessings Cleaning LLC, we are committed to providing top-notch cleaning services that ensure your environment is clean, safe, and welcoming.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Comprehensive cleaning solutions for homes and businesses in Detroit.',
      cards: [
        {
          title: 'Deep Cleaning',
          description:
            'Thorough cleaning services that leave your space immaculate.',
          imageSrc: 'https://media.istockphoto.com/id/1724689214/photo/furniture-deep-cleaning.jpg?s=612x612&w=0&k=20&c=GdrTUquDon2WfoG1aykTJ330Z_BvK9Oew8hZsyAhjpA=',
          imageAlt: 'Deep Cleaning Service',
        },
        {
          title: 'Move-In/Move-Out Cleaning',
          description:
            'Ensure a fresh start or leave a lasting impression with our move-in/move-out cleaning services.',
          imageSrc: 'https://media.istockphoto.com/id/1346293234/photo/moving-boxes-in-new-apartment-and-carton-box-on-floor-move-house-concept.jpg?s=612x612&w=0&k=20&c=ybw2jOYND_nBzkt7xuK2tK5TSYv5Lxvs9Z9rOJPjRmA=',
          imageAlt: 'Move-In/Move-Out Cleaning',
        },
        {
          title: 'Office Cleaning',
          description:
            'Maintain a professional and hygienic workspace with our office cleaning services.',
          imageSrc: 'https://media.istockphoto.com/id/2159632844/photo/commercial-office-cleaners.jpg?s=612x612&w=0&k=20&c=1cgFp-uxCXLAXY9yAB_hQNZqq6hcTZ0bVG77D7njKVY=',
          imageAlt: 'Office Cleaning Service',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Regular Maintenance Cleaning',
        'Post-Construction Cleaning',
        'Event Cleanup',
        'Eco-Friendly Cleaning Options',
        'Customized Cleaning Plans',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://img1.wsimg.com/isteam/getty/944124508/:/rs=w:370,cg:true,m',
        alt: 'Bountiful Blessings Cleaning Team',
      },
      aboutText: [
        'Bountiful Blessings Cleaning LLC is a Detroit-based cleaning company dedicated to providing exceptional cleaning services tailored to your needs.',
        'Our mission is to ensure that your office or facility is clean, safe, and welcoming for everyone. We also offer home cleaning services.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Bountiful Blessings Cleaning Logo',
      businessName: 'Bountiful Blessings Cleaning LLC',
      contact: {
        phone: '3136361833',
        phoneLabel: '+1 (313) 636-1833',
        email: 'info@bountifulblessingscleaningllc.com',
        website: 'https://bountifulblessingscleaningllc.com/',
        address: '17910 Van Dyke Street, Suite 1310, Detroit, MI 48234, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '17910 Van Dyke Street, Suite 1310, Detroit, MI 48234, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2948.22!2d-83.006176!3d42.439915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824d2f2f379fb1d%3A0x7d9a12b9a3dbf42e!2s17910%20Van%20Dyke%20St%20%231310%2C%20Detroit%2C%20MI%2048234%2C%20USA!5e0!3m2!1sen!2sus!4v1712852399999!5m2!1sen!2sus',
    },
  },
};

export default config;
